<pep-message-dialog [title]="'Löschen'"
              [showCancelButton]="true"
              [acceptButtonText]="'Löschen'"
              (pushAccept)="save()"
              (pushCancel)="closeDialog()"
              (pushClose)="closeDialog()">
    <div style="padding-bottom: 10px;">
        {{ text }}
    </div>
</pep-message-dialog>
